import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isMultiple", "isReadonly", "placeholder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Select, Space } from 'antd';
import { TaskType } from 'core/modules/tasks/task.interface';
import { useTranslation } from 'react-i18next';
import { TaskTypeTag } from 'src/components/Tasks/TypeTag';
import { sanitizeAll } from '../../utils/sanitize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Renders a select to select a state. */
export var TaskTypeSelect = function TaskTypeSelect(_ref) {
  var isMultiple = _ref.isMultiple,
      isReadonly = _ref.isReadonly,
      placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, props), {}, {
    mode: isMultiple ? 'multiple' : undefined,
    showSearch: true,
    bordered: !isReadonly,
    disabled: isReadonly,
    filterOption: function filterOption(input, option) {
      return sanitizeAll(option.title).includes(sanitizeAll(input));
    },
    tagRender: function tagRender(item) {
      return /*#__PURE__*/_jsx(TaskTypeTag, {
        type: item.value,
        withTooltip: true
      });
    },
    placeholder: isReadonly ? undefined : placeholder !== null && placeholder !== void 0 ? placeholder : t('form.task.type.placeholder'),
    children: Object.values(TaskType).map(function (type) {
      return /*#__PURE__*/_jsx(Select.Option, {
        value: type,
        title: t("form.task.type.values.".concat(type)),
        children: /*#__PURE__*/_jsxs(Space, {
          size: "small",
          children: [/*#__PURE__*/_jsx(TaskTypeTag, {
            type: type
          }), /*#__PURE__*/_jsx("span", {
            className: "label",
            children: t("form.task.type.values.".concat(type))
          })]
        })
      }, type);
    })
  }));
};